import BillingRoot from '../components/micro-front-ends/Billing'
import { store } from '../store'
import { BaseRouteEnum } from '@/enums/modules/routes'

export default [
  {
    path: '/billing*',
    meta: { showSideNav: true },
    name: 'Billing',
    component: BillingRoot,
    beforeEnter (to, from, next) {
      // if a subaccount user of a powered by account tries to load billing information
      // redirect them to the Dashboard instead
      const { isPoweredBySubAccountUser } = store.getters['user/getExternalIdInfo']
      const { isAdmin } = store.getters['user/getUser']
      if (!isAdmin && isPoweredBySubAccountUser) {
        next({ name: BaseRouteEnum.DashboardV2 })
      } else {
        next()
      }
    }
  }
]
